import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content.types";
import { EngagementContent } from "PFApp/components/card_tx/content/engagement_content";
import { EngagementFooter } from "PFApp/components/card_tx/footer/engagement_footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type AuditEngagementVariantProps = Pick<
  CardTxContentProps,
  "activity" | "type" | "isFeed" | "isDraft" | "numberOfRoles" | "handleShare"
>;

export const AuditEngagementVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  numberOfRoles,
  handleShare
}: AuditEngagementVariantProps) => (
  <>
    <Header activity={activity} type={type} isFeed={isFeed} onShare={handleShare} />
    <Status isPrivate={activity.private} isDraft={isDraft} />
    <EngagementContent activity={activity} isFeed={isFeed} />
    <EngagementFooter numberOfRoles={numberOfRoles} />
  </>
);
